// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1O9a6","modalFooterButton":"ModalNotes_modalFooterButton__id7K2"};